import ky from 'ky';
import Config from '../../config';

export interface CreditsPageData {
    id: number;
    title: string;
}

export interface CreditsPageDetailData extends CreditsPageData {
    content: string;
    lastupdate: number;
}

export interface CreditsIndexData {
    name: string;
    pages: CreditsPageData[];
}

class CreditsUtils {
    private pathname: string;
    private index: Promise<CreditsIndexData | null> | null = null;

    constructor(path: string) {
        this.pathname = path;
    }

    getIndexUrl(): string {
        return `${this.pathname}/`;
    }

    getPageUrl(id: number): string {
        return this.getIndexUrl() + (0 === id ? 'aboutus.php' : `?id=${id}`);
    }

    private getDataUrl(fname: string): URL {
        return new URL(Config.BASE_URL + this.getIndexUrl() + fname, window.location.href);
    }

    /** Fetched once; concurrent callers share the request. */
    getIndex(): Promise<CreditsIndexData | null> {
        if (this.index === null) {
            this.index = ky
                .get(this.getDataUrl('index.json'))
                .json<CreditsIndexData>()
                .catch(() => null);
        }
        return this.index;
    }

    async getPage(id: number): Promise<CreditsPageDetailData | null> {
        try {
            return await ky.get(this.getDataUrl(`${id}.json`)).json<CreditsPageDetailData>();
        } catch {
            return null;
        }
    }
}

export default new CreditsUtils('/modules/credits');
